import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles } from "lucide-react";

// Ce que le propriétaire corrige dans les propositions de Lia (données réelles, sans IA) — alimente le prompt de rédaction.
export const GoogleReplyInsights = ({ estId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/google/reply-insights/${estId}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [estId]);
  if (!d) return null;
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 text-sm space-y-2 lg:col-span-2" data-testid="gbp-reply-insights">
      <h3 className="font-heading font-bold flex items-center gap-2"><Sparkles className="w-4 h-4 text-blue-600" /> Ce que Lia apprend de vos corrections</h3>
      {!d.available ? <p className="text-slate-500" data-testid="gbp-insights-empty">{d.note}</p> : <>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <div><div className="text-xs text-slate-500">Réponses publiées via Lia</div><div className="text-xl font-bold">{d.published_from_lia}</div></div>
          <div><div className="text-xs text-slate-500">Modifiées avant publication</div><div className="text-xl font-bold">{d.edit_rate} %</div></div>
          <div><div className="text-xs text-slate-500">Longueur ajustée</div><div className="text-xl font-bold">{d.avg_length_delta_pct > 0 ? "+" : ""}{d.avg_length_delta_pct} %</div></div>
          <div><div className="text-xs text-slate-500">Emojis retirés</div><div className="text-xl font-bold">{d.emoji_removed}</div></div>
        </div>
        {d.lessons?.length > 0 ? <ul className="list-disc pl-5 space-y-1 text-slate-700" data-testid="gbp-insights-lessons">{d.lessons.map((l, i) => <li key={i}>{l}</li>)}</ul> : <p className="text-slate-500">Pas encore de tendance nette : Lia continue avec vos réglages.</p>}
        <p className="text-xs text-slate-400">{d.note}{d.edited >= 3 ? " Ces enseignements sont injectés dans les prochaines propositions." : " À partir de 3 réponses modifiées, Lia adapte ses propositions."}</p>
      </>}
    </div>
  );
};
